export const actionButtonGroupStyles = {
	button: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		minWidth: 'max-content',
		height: '32px',
		fontWeight: 700,
		lineHeight: 1
	},
	trigger: {
		whiteSpace: 'nowrap',
		height: '32px',
		fontWeight: 700,
		lineHeight: 1
	},
	menuItem: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 1
	}
};
